import { literal, union } from 'io-ts/Decoder';

export const Source = union(literal('ai'), literal('user'));
